import { restAxios } from './httpClient';
import { stripBlankParams } from '../helpers/queryParams';

const FIRMWARE_ADVISORIES_PATH = '/hardware/firmware-advisories';

/*
 * Flipping the status filter or paging fires a request per gesture, and the responses can come
 * back out of order. Aborting the in-flight read keeps the table showing the latest query rather
 * than whichever response happened to land last.
 */
let getFirmwareAdvisoriesController;

export const getFirmwareAdvisories = (queryParams) => {
	getFirmwareAdvisoriesController?.abort();

	getFirmwareAdvisoriesController = new AbortController();
	const searchParams = new URLSearchParams(stripBlankParams(queryParams)).toString();

	return restAxios.get(`${FIRMWARE_ADVISORIES_PATH}?${searchParams}`, {
		signal: getFirmwareAdvisoriesController.signal
	});
};

/*
 * Both writes answer with a job id rather than the advisory, so neither is finished when the
 * promise resolves - the caller has to poll the job. See the thunks in data/firmwareAdvisory.
 */
export const createFirmwareAdvisory = (payload) => {
	return restAxios.post(FIRMWARE_ADVISORIES_PATH, payload);
};

export const updateFirmwareAdvisory = (id, payload) => {
	return restAxios.patch(`${FIRMWARE_ADVISORIES_PATH}/${id}`, payload);
};
